import { gql } from '@biletiniz/apollo';

export const FLIGHT_SEARCH_SESSION_QUERY = gql`
  query flightSearchSession($session: String!) {
    flightSearchSession(session: $session) {
      session
      remainingSeconds
      isExpired
    }
  }
`;
